export default {"src":"/_next/static/media/google-g-logo.a172c66b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};